












































































































































import {
  Component,
  Vue,
  Watch
} from "@/shared/vuepack";
import {
  HsabAccountNametag,
  HsabSsoDestination
} from "@/shared/types";
import moment from "moment";
import * as RouteNames from "@/employee/route-names";
import ValueBadge from "@/shared/components/ui/ValueBadge.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import HsabInvestmentRedirectPage from "@/employee/components/investments/HsabInvestmentRedirectPage.vue";
import {
  hsabAccountIcon,
  hsaPlanTypeIcon
} from "@/shared/awesomeIconMapper";
import HsaSubMenu from "@/employee/components/advancedDashboard/HsaSubMenu.vue";
import { useUserStore } from "@/shared/store/user";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useNavigationStore } from "@/shared/store/navigation";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {
    ValueBadge,
    SsoDeepLink,
    HsabInvestmentRedirectPage,
    HsaSubMenu,
  }
})
export default class AdvancedNav extends Vue {
  userStore = useUserStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  custodianSettingsStore = useCustodianSettingsStore();
  navigationStore = useNavigationStore();
  bankAccountStore = useBankAccountStore();
  featureFlagStore = useFeatureFlagStore();
  hsabInvestmentStore = useHsabInvestmentStore();
  hsabAccountsStore = useHsabAccountsStore();

  afterRoutedHook: any;

  RouteNames = RouteNames;

  hsaContainerIsVisible = false;

  @Watch("hsabAccountsStore.accountsFetchState")
  updateVisibleContainer () {
    if (this.hsabAccountsStore.hsaAccount.length > 0 && this.hsabAccountsStore.notionalAccounts.length < 1) {
      this.hsaContainerIsVisible = true;
    }
  }

  @Watch("$route")
  watchRoute (newRoute, oldRoute) {
    this.handleInsideCollapse(newRoute);
  }

  handleInsideCollapse (newRoute) {
    const insideCollapse = this.routesInsideHsaCollapse.some(x => x === newRoute.name);
    if (insideCollapse) {
      this.hsaContainerIsVisible = true;
    }
  }

  closeNav () {
    this.navigationStore.closeMobileMenu();
  }

  isRouteUrlActive (url: string, exact = false) {
    if (exact) {
      return this.$route.path.toLowerCase() === url.toLowerCase();
    } else {
      return this.currentRouteStartsWith(url);
    }
  }

  isRouteNameActive (routeName: string) {
    return this.$route.name === routeName;
  }

  currentRouteStartsWith (url: string) {
    return this.$route.path.indexOf(url) === 0;
  }

  mounted () {
    this.updateVisibleContainer();
    this.handleInsideCollapse(this.$route);
  }

  get routesInsideHsaCollapse () {
    const results = [
      RouteNames.Home,
      RouteNames.CashBalance,
      RouteNames.InvestmentAccountInfo,
      RouteNames.EligibleExpenses,
      RouteNames.HealthcareExpenses,
      RouteNames.Contribution,
      RouteNames.ContributionPlanner,
      RouteNames.ProductScanner,
    ];

    if (this.showResourcesLinkUnderHsa) {
      results.push(RouteNames.Resources);
    }

    return results;
  }

  get isEverythingLoaded () {
    return this.custodianSettingsStore.isLoaded && this.featureFlagStore.featureFlagsAvailable;
  }

  get showExpenseManagementLink (): boolean {
    return this.featureFlagStore.flags.bend16432HsabExpenseManagement
        && this.hsabAccountsStore.userHasAnyNotionalAccounts;
  }

  get showAccountsSummaryLink (): boolean {
    return this.hsabAccountsStore.userHasAnyActiveAccount &&
        this.hsabAccountsStore.userHasAnyNotionalAccounts;
  }

  get userHasHsaAccount (): boolean {
    return this.hsabAccountsStore.hsaAccount && this.hsabAccountsStore.hsaAccount.length > 0;
  }

  get showClosedAccountsLink (): boolean {
    return this.featureFlagStore.flags.bend18236ClosedAccountSummaryPage
        && !this.hsabAccountsStore.userHasAnyActiveAccount
        && this.userHasInactiveAccounts;
  }

  get userHasInactiveAccounts (): boolean {
    return this.hsabAccountsStore.userHasAnyInactiveAccount;
  }

  get showExpensesLink (): boolean {
    const { HealthcareExpenses } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[HealthcareExpenses]) {
      return false;
    }

    return true;
  }

  get hsabDeepLinkDashboard () {
    return HsabSsoDestination.Dashboard;
  }

  get hsabDeepLinkHome () {
    return HsabSsoDestination.Home;
  }

  get hsabDeepLinkPayment () {
    return HsabSsoDestination.DistributeFund;
  }

  get hsabDeepLinkMessageCenter () {
    return HsabSsoDestination.MessageCenter;
  }

  get hsabDeepLinkFileClaim () {
    return HsabSsoDestination.FileClaim;
  }

  get showResourcesLinkUnderHsa (): boolean {
    const { Resources } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Resources]) {
      return false;
    }

    if (this.featureFlagStore.flags.bend16364HsabResourceNavigation === false) {
      return true;
    }

    return this.hsabAccountsStore.notionalAccounts.length === 0;
  }

  get showResourcesLinkUnderRoot (): boolean {
    const { Resources } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Resources]) {
      return false;
    }

    if (this.featureFlagStore.flags.bend16364HsabResourceNavigation === false) {
      return false;
    }

    return this.hsabAccountsStore.notionalAccounts.length > 0;
  }

  get showSettingsLink (): boolean {
    const { Settings } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Settings]) {
      return false;
    }

    return true;
  }

  get showNotionalAccountsLinks () {
    return (this.notionalNavItems && this.notionalNavItems.length > 0) || this.userHasInactiveAccounts;
  }

  get showReimburseLink (): boolean {
    return this.custodianSettingsStore.allowReimbursement && !this.bankAccountStore.isBankAccountClosed;
  }


  created () {
    this.expenseBalanceSummaryStore.loadState();
    this.afterRoutedHook = this.$router.afterEach(this.closeNav);
    this.custodianSettingsStore.getCustodianSettings();
    this.bankAccountStore.getBankAccountStatus();
  }

  get notionalNavItems () {
    return this.hsabAccountsStore.notionalAccounts.filter(t => t.isActive).map(t => {
      return {
        planType: t.planType,
        header: this.notionalAccountName(t),
        accountId: t.accountId,
        icon: hsabAccountIcon(t)
      };
    });
  }
  notionalAccountName (notionalAccount: HsabAccountNametag): string {
    if (notionalAccount.startDate === null || notionalAccount.endDate === null) {
      return notionalAccount.accountName;
    }
    const startYear = moment(notionalAccount.startDate).year();
    let endYear = moment(notionalAccount.endDate).year();
    if (startYear === endYear) {
      return `${notionalAccount.accountName} (${startYear})`;
    }
    endYear = moment(notionalAccount.endDate, "YYY").year();
    return `${notionalAccount.accountName} (${startYear}-${endYear})`;
  }
  get hsaIcon () {
    return hsaPlanTypeIcon();
  }

  beforeDestroy () {
    this.afterRoutedHook();
  }
}

